import { cn } from "@/lib/utils";
import { useUser } from "@/providers/user";
import { UserGroups, UserProfile } from "@/types/user";
import { NavLink, Outlet } from "react-router-dom";

export default function SettingsLayout() {
    const { has_any_group, has_any_profile } = useUser();

    const settings: { name: string; groups?: UserGroups[]; profiles?: string[]; items: { name: string; href: string; groups?: UserGroups[] }[] }[] = [
        {
            name: "My account",
            items: [
                {
                    name: "General",
                    href: "/parametres/mon-compte"
                },
                {
                    name: "Vault TOTP",
                    href: "/parametres/coffre"
                }
            ]
        },
        {
            name: "Apprenticeship",
            groups: ["app_apprenticeship_admin"],
            items: [
                {
                    name: "Attributions",
                    href: "/parametres/alternance/attributions"
                },
                {
                    name: "Availability management",
                    href: "/parametres/alternance/disponibilites"
                }
            ]
        },
        {
            name: "Targets Management",
            profiles: ["system_admin"],
            items: [
                {
                    name: "Objectives",
                    href: "/parametres/targets/objectives"
                },
                {
                    name: "Payplans",
                    href: "/parametres/targets/payplans"
                },
                {
                    name: "Process objectives",
                    href: "/parametres/targets/process-objectives"
                },
                {
                    name: "Simulator",
                    href: "/parametres/targets/simulator"
                }
            ]
        },
        {
            name: "CRM permissions",
            profiles: ["system_admin"],
            items: [
                {
                    name: "Permissions by profile",
                    href: "/parametres/crm/permissions"
                },
                {
                    name: "Sharing rules",
                    href: "/parametres/crm/sharing-rules"
                },
                {
                    name: "Vault audit",
                    href: "/parametres/coffre/audit"
                }
            ]
        }
    ];

    return (
        <main className="flex min-h-[calc(100vh_-_theme(spacing.16))] flex-1 flex-col gap-4 p-4">
            <div className="mx-auto grid w-full gap-2">
                <h1 className="text-2xl font-semibold">Settings</h1>
            </div>
            <div className="mx-auto grid w-full items-start gap-4 md:grid-cols-[180px_1fr] lg:grid-cols-[250px_1fr]">
                <nav className="space-y-5 text-sm text-muted-foreground">
                    {settings
                        .filter(section => {
                            // Vérifier les groupes si spécifiés
                            if (section.groups && section.groups.length > 0) {
                                return has_any_group(section.groups);
                            }
                            // Vérifier les profils si spécifiés
                            if (section.profiles && section.profiles.length > 0) {
                                return has_any_profile(section.profiles as UserProfile[]);
                            }
                            // Si ni groupes ni profils spécifiés, toujours afficher
                            return true;
                        })
                        .map((section, i) => (
                            <div className="grid gap-2" key={`${i}_${section.name}`}>
                                <h4 className="text-lg font-medium">{section.name}</h4>
                                {section.items
                                    .filter(item => has_any_group(item.groups || []))
                                    .map((item, j) => (
                                        <NavLink
                                            to={item.href}
                                            className={({ isActive }) => {
                                                return cn(isActive ? "font-semibold text-primary" : "");
                                            }}
                                            key={`${j}_${item.name}`}
                                        >
                                            {item.name}
                                        </NavLink>
                                    ))}
                            </div>
                        ))}
                </nav>
                <div className="grid gap-6">
                    <Outlet />
                </div>
            </div>
        </main>
    );
}
